<template lang="html">
  <div class="userRoleDropdown">

	<!-- <vs-select class="roleDropdown" v-model="user.role_id" v-on:change="$emit('roleUpdate')" >
	    <vs-select-item :key="role.role_id" :text="role.description" v-for="role in roles" :value="role.role_id" />
	</vs-select> -->

	<div class="w-full">
		<v-select class="select-role vue-select" :clearable="false" :searchable="false" v-model="user.role_id" :reduce="item => item.role_id" v-on:input="$emit('roleUpdate')" :options="roles" label="description">
		</v-select>
	</div>

  </div>
</template>

<script>

//load configurations on theme
import themeConfig from '@/../themeConfig.js';

// import axios
import axios from 'axios';

export default {
	data(){
		return {
			default_role : '',
			newRole: '',
		}
	},
	props: [
		'user', 'roles'
	],
	mounted: function(){
		
	},
	methods: {

	}
}

</script>

<style>
	.role_text {
		margin-bottom: 25px;
	}
	.select-role .vs__dropdown-menu {
		top: 1px;
	}
	.select-role {
		width: 220px;
	}
</style>